import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify"; // Assuming you're using react-toastify for toasts
import api from "../api";
import DealApi from "../../feature-module/crm/deals/api/DealApi";
import LeadApi from "../../feature-module/crm/leads/api/LeadApi";

export const useCallHandler = (moduleName, id) => {
  const mutation = useMutation({
    mutationFn: (mobileNo) =>
      api.post("/system-call/agentManualDial", {
        customerPhone: mobileNo,
      }),
    onSuccess: (res) => {
      // Access success message from the backend response
      const successMessage = res.data?.msg || "Call initiated successfully!";
      toast.success(successMessage);

      // Prepare the activity message based on the module
      const activityMessage =
        moduleName === "leads"
          ? `<b>Call Details:</b> ${successMessage}`
          : `<b>Deal Call Details:</b> ${successMessage}`;

      // Update the timeline for the respective module
      if (moduleName === "leads") {
        LeadApi.updateLead(id, {
          textMessageAboutActivity: activityMessage,
        });
      } else {
        DealApi.updateDeal(id, {
          textMessageAboutActivity: activityMessage,
        });
      }
    },
    onError: (e) => {
      const errorMessage =
        e.response?.data?.msg || "Call failed. Please try again.";
      toast.error(errorMessage);
    },
  });

  return mutation;
};
